import { render, staticRenderFns } from "./StampAttachmentDialog.vue?vue&type=template&id=1f5f3a10&scoped=true"
import script from "./StampAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./StampAttachmentDialog.vue?vue&type=script&lang=js"
import style0 from "./StampAttachmentDialog.vue?vue&type=style&index=0&id=1f5f3a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f3a10",
  null
  
)

export default component.exports